import { PayloadAction, createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getNotifications } from "../../services/notiService";

export interface INotification
{
  id: string | number;
  title: string;
  message?: string;
  createAt: string | Date;
  read?: boolean;
  tags?: string[];
}

interface INotificationState
{
  type: "success" | "error" | "warning" | "info" | "loading";
  content: string;
  status: boolean;
  total?: INotification[]
}

const initialState: INotificationState = {
  type: "success",
  content: "",
  status: false,
  total: []
};

export const getNotificationsAsync = createAsyncThunk(
  "notifications/getNotifications",
  async (payload: any) =>
  {
    try
    {
      const response = await getNotifications(payload);
      return response;
    } catch (e: any)
    {
      console.log(e, "error");

      return {
        message: e?.response?.data?.message,
      };
    }
  }
);

export const notificationSlice = createSlice({
  name: "notifications",
  initialState,
  reducers: {
    displayNotification: (
      state,
      action: PayloadAction<{
        type: "success" | "error" | "warning" | "info" | "loading";
        content: string;
      }>
    ) =>
    {
      state.type = action?.payload.type;
      state.content = action?.payload.content;
      state.status = !state.status;
    },

    changeTotalNotifications: (state, action?: any) =>
    {
      state.total = action.payload.map((n: any) => ({
        ...n,
        read: n.read ?? false,
      }));
    },

    markAsRead: (state, action: PayloadAction<string | number>) =>
    {
      const notification = state.total?.find((n) => n.id === action.payload);
      if (notification)
      {
        notification.read = true;
      }
    },

    markAllAsRead: (state) =>
    {
      if (state.total)
      {
        state.total.forEach((n) => (n.read = true));
      }
    },

    addNotification: (state, action: PayloadAction<INotification>) =>
    {
      // Prepend new notification to the list
      state.total = [action.payload, ...(state.total || [])];
    },
  },
});

export const { displayNotification, changeTotalNotifications, markAsRead, markAllAsRead, addNotification } = notificationSlice.actions;

export default notificationSlice.reducer;
